// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-recovery-modal__switch-button{margin:20px 0 0}`, "",{"version":3,"sources":["webpack://./client/modules/Modals/PasswordRecoveryModal/_password-recovery-modal.scss"],"names":[],"mappings":"AAGE,wCACE,eAAA","sourcesContent":["@import 'styles/palette';\n\n.password-recovery-modal {\n  &__switch-button {\n    margin: 20px 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
